import React from "react";

import { convertToDollars } from "utils/payment/helpers";

import CreditsPurchased from "assets/images/icons/creditsPurchased.svg";
import CreditsIn from "assets/images/icons/creditsIn.svg";
import CreditsOut from "assets/images/icons/creditsOut.svg";
import creditsInsights from "assets/images/icons/creditsInsights.svg";
import creditsParametric from "assets/images/icons/creditsParametric.svg";
import DownloadLight from "assets/images/icons/downloadLight.svg";
import Download from "assets/images/icons/JSX/Dowload.jsx";

import classes from "./styles.module.scss";
import Button from "components/Button";

const IMAGES_AND_TITLE = {
    PURCHASED: { image: CreditsPurchased, title: "Credits Purchased" },
    TRANSFER_IN: { image: CreditsIn, title: "Credits Received" },
    TRANSFER_OUT: { image: CreditsOut, title: "Credits Sent" },
    "SPENT.INSIGHTS": { image: creditsInsights, title: "Insights" },
    "SPENT.PARAMETRIC": { image: creditsParametric, title: "Parametric Analysis" },
};

const MainDetails = ({
    transactionType = "",
    amountInCents = 0,
    receiptUrl = null,
    invoice = "in_1Rvmhp2YpVlxUt7bL5HBaaEu",
}) => {
    const { image, title } = IMAGES_AND_TITLE[transactionType] || {};
    return (
        <div className={classes.mainDetailsContainer}>
            <div className={classes.iconTitleContainer}>
                {image && <img src={image} alt={title} />}
                {title && <span>{title}</span>}
            </div>
            {transactionType === "PURCHASED" && (
                <div className={classes.transactionDetailsContainer}>
                    <span className={classes.transactionDetailsText}>${convertToDollars(amountInCents)}</span>
                    <span className={classes.transactionDetailsInvoice}>{invoice}</span>
                    <a
                        className={classes.downloadReceiptLink}
                        href={receiptUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Download colour="#646F81" width="9" height="9" />
                        <span className={classes.downloadReceiptText}>Download Receipt</span>
                    </a>
                </div>
            )}
        </div>
    );
};

export default MainDetails;
